const context = 'app'

export const SIGN_IN = `${context}/SIGN_IN`

export const SIGN_OUT = `${context}/SIGN_OUT`

export const UPDATE_OFFSET = `${context}/UPDATE_OFFSET`

export const SET_CURRENT_PAGINATION_CONFIG = `${context}/SET_CURRENT_PAGINATION_CONFIG`

export const SET_SCREEN_SCROLL_OFFSET = `${context}/SET_SCREEN_SCROLL_OFFSET`

export const SET_BANNER_IS_OPEN = `${context}/SET_BANNER_IS_OPEN`

export const SET_QUERY_STRING_PARAMETERS = `${context}/SET_PARAMS`
export const SET_QUERY_STRING_PARAMETERS_TO_DEFAULT = `${context}/SET_QUERY_STRING_PARAMETERS_TO_DEFAULT`
